import { styled } from "styled-components";

export const PanelContainer = styled.div`
  width: 100%;
  border-bottom: 1px solid;
  border-left: 1px solid;
  border-right: 1px solid;
  border-radius: 0px 0px 4px 4px;
  border-color: var(--palette-border-neutral-subtle);
  display: flex;
  flex-direction: column;
  background-color: var(--palette-bg-neutral-base);
  margin-bottom: 12px;
  padding-bottom: 8px;
`;

export const PanelPadding = styled.div`
  padding: 32px 32px 20px;
  @media (max-width: 768px) {
    padding: 0;
  }
`;
